import { render, staticRenderFns } from "./Originaldata.vue?vue&type=template&id=8f3d5ad0&style=height%3A100%25%2Cwidth%3A100%25"
import script from "./Originaldata.vue?vue&type=script&lang=js"
export * from "./Originaldata.vue?vue&type=script&lang=js"
import style0 from "./Originaldata.vue?vue&type=style&index=0&id=8f3d5ad0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports